import { render } from "./OfficePanel.vue?vue&type=template&id=11a1e46c&scoped=true&ts=true"
import script from "./OfficePanel.vue?vue&type=script&lang=ts"
export * from "./OfficePanel.vue?vue&type=script&lang=ts"

import "./OfficePanel.vue?vue&type=style&index=0&id=11a1e46c&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-11a1e46c"]])

export default __exports__